export default "__VITE_ASSET__OO3iSxmr__ 800w";